export default __webpack_public_path__ + "static/media/pizza-signin.dacc5f23.jpg";